var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9197 0.897582L24.1073 2.31357C23.4648 2.39058 23.0058 2.97386 23.0829 3.61703L23.3647 5.96807C23.4417 6.61052 24.0257 7.06949 24.6681 6.99248L29.6578 6.39436L20.6719 17.8271L15.8247 14.0176C14.8012 13.2138 13.32 13.3914 12.5155 14.4143L2.91473 26.6319C2.51432 27.1405 2.6027 27.8779 3.11199 28.2775L4.97358 29.7412C5.48215 30.1409 6.21948 30.0525 6.61917 29.5439L14.7654 19.1787L19.6118 22.9883C20.6354 23.793 22.1169 23.6158 22.9211 22.5916L33.3622 9.3064L33.9603 14.296C34.0373 14.9385 34.6206 15.3975 35.2638 15.3204L37.6148 15.0386C38.258 14.9615 38.7163 14.3776 38.6392 13.7352L37.2232 1.92199C37.1461 1.27882 36.5629 0.820484 35.9197 0.897582Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressArrow);
export default __webpack_public_path__ + "static/media/progressArrow.264ee09f858d727ccdcc8bcd227a0ec3.svg";
export { ForwardRef as ReactComponent };